//
// abstract definitions for storing in JSON
// these can't change without migrating existing JSON ⚠️
//
export const enum Size {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
  ORIGINAL = "ORIGINAL",
}

export const enum Alignment {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

//
// concrete definitions for styling (can change)
//
export const CSS_SIZE = {
  [Size.SMALL]: "basis-3/4 max-w-[350px]",
  [Size.MEDIUM]: "basis-full max-w-[550px]",
  [Size.LARGE]: "basis-full max-w-[820px]",
  [Size.ORIGINAL]: "",
};

export const CSS_ALIGNMENT = {
  [Alignment.LEFT]: "justify-start",
  [Alignment.CENTER]: "justify-center",
  [Alignment.RIGHT]: "justify-end",
};
